module.exports = __webpack_public_path__ + "img/mindan.a5f6ec0c.png";